// extracted by mini-css-extract-plugin
export default {"addMovieButton":"addMovieButton__addMovieButton__MSS7k"};